import React from 'react';
import { Form, Input} from 'antd';
import { useTranslation } from 'react-i18next';

const FormItemTitle = () => {		

  const { t } = useTranslation();	

  return (		
	<Form.Item
    label={t('view.forms.fields.title.label')}
    name='title'
    rules={[
        { 
            required: true, 
            message: t('view.forms.fields.title.required') as string 
        },
        { 
            max: 58, 
            message: 'El título no puede superar los 58 caracteres' // O tu t('...')
        }
    ]}>
			<Input placeholder={t('view.forms.fields.title.placeholder') as string} maxLength={58} showCount style={{ borderRadius: '2px' }}/>
		</Form.Item>							
	)
}

export default FormItemTitle;
